import { ProductReviewModel } from "./product-review.model";

export class ProductDetailInfoModel {
  catId: Number;
  productId: Number;
  langId: Number;
  optionId?: Number;
  countryId: Number;
  destinationId: Number;
  extranetId: Number;
  ratingPoint: Number;
  latitude: Number;
  longitude: Number;
  restrictDestination: Boolean;
  extranetEnable: Boolean;
  isAllotControl: Boolean;
  status: Boolean;
  active: Boolean;
  countryTitle: string;
  destinationTitle: string;
  catTitle: string;
  catTitleSlug: string;
  title: string;
  titleEngProductCat: string;
  titleEngDestination: string;
  titleEngCountry: string;
  detailShort: string;
  detailFull: string;
  slug: string;
  address: string;
  WSContent: any;
  checkInTimeFrom: string;
  checkInTimeUntil: string;
  checkOutTimeFrom: string;
  checkOutTimeUntil: string;
  reviewRating: ProductReviewModel;
  minGuestAge: number;
  childPolicies: ChildPolicy[];
  remarks: Remark[];
  crossCondition: Boolean;
  displayLabels?: DisplayLabel[] = [];
  sanitation: Sanitation[];
}

export class Remark {
  th: String;
  en: String;
}

export class ChildPolicy {
  isInfant: Boolean;
  ageFrom: number;
  ageTo?: number;
  isFree: Boolean;
}

export class ChildPolicyDislay {
  policy: String;
  stayFree: String;
  description: String;
}

export class DisplayLabel {
  name: string;
  value: string;
}

export class ProductDisplayLabel {
  public static readonly SHA = 'SHA';
  public static readonly SHA_PLUS = 'SHA+';
  public static readonly YEAR_OF_BUILD = 'YearOfBuild';
  public static readonly YEAR_OF_RENOVATED = 'YearOfRenovated';
  public static readonly SECURITY_STANDARD = 'SecurityStandard';
}

export class Sanitation {
  id: number;
  title: string;
  icon: string;
}



// WEBPACK FOOTER //
// ./src/app/model/products/product-detail-info.model.ts